import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_API_KEY = 'board/:boardId/reporting/summary';

const emptySummary: Api.IOpportunitySummary = {
	totalOpportunities: 0,
	totalDealSize: 0,
	averageDealSize: 0,
};

export function useOpportunityReportingSummaryQuery({
	boardId,
	filterRequest,
	enabled,
	refetchOnWindowFocus = false,
}: {
	boardId: string;
	filterRequest: Api.IOpportunityReportingFilterRequest;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		meta: {
			toastErrorMessage: 'Failed to load opportunity reporting summary',
		},
		queryFn: async () => {
			const value = await userSession.webServiceHelper.callAsync<Api.IOpportunitySummary>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `board/${boardId}/reporting/summary`,
				}),
				'POST',
				filterRequest
			);
			return value ?? emptySummary;
		},
		queryKey: [BASE_API_KEY, boardId, filterRequest],
		refetchOnWindowFocus,
	});
}
